import { Component, OnInit } from '@angular/core';
import { LUCIDE_ICONS, LucideAngularModule, LucideIconProvider, icons } from 'lucide-angular';
import { Store } from '@ngrx/store';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { login } from '../../store/Authentication/authentication.actions';
import { RouterModule } from '@angular/router';
import { AuthError, SignInInput } from 'aws-amplify/auth';
import { CognitoService } from '../../services/cognito.service';
import { CommonModule } from '@angular/common';
import { NotificationService } from '../../services/notification.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [LucideAngularModule, FormsModule, ReactiveFormsModule, RouterModule, CommonModule],
  templateUrl: './login.component.html',
  styles: ``,
  providers: [{ provide: LUCIDE_ICONS, multi: true, useValue: new LucideIconProvider(icons) }]

})
export class LoginComponent implements OnInit {
  // Login Form
  loginForm!: UntypedFormGroup;
  submitted = false;
  fieldTextType: boolean = false;
  error = '';
  returnUrl!: string;
  a: any = 10;
  b: any = 20;
  toast!: false;

  // set the current year
  year: number = new Date().getFullYear();

  loading = false;

  // tslint:disable-next-line: max-line-length
  constructor(private formBuilder: UntypedFormBuilder,
    private router: Router,
    private store: Store,
    public cognitoService: CognitoService,
    private notificationService: NotificationService,
    private traslateService: TranslateService
  ) {

  }

  ngOnInit(): void {
    if (sessionStorage.getItem('currentUser')) {
      this.router.navigate(['/']);
    }
    /**
     * Form Validatyion
     */
    this.loginForm = this.formBuilder.group({
      user: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  /**
   * Form submit
   */
  async login() {
    this.submitted = true;
    this.loading = false;

    let user = this.f['user'].value; 
    const password = this.f['password'].value; // Get the password from the form
    // Login Api
    // this.store.dispatch(login({ email: email, password: password }));

    if (this.loginForm.invalid) {
      return;
    }

    if (typeof user === 'string') {
      user = user.trim().toLowerCase();
    }
    const isEmail = /^[a-zA-Z0-9.!#$%&*+/=?^_`{|}~-]+@[a-zA-Z0-9~-]+(?:\.[a-zA-Z0-9-]+)*$/.test(user!.toString());
    if (isEmail) {
      this.loading = true;
      this.loginManager(user!.replace(/\s/g, ''), password!.replace(/\s/g, ''));
    }
  }

  async loginManager(mail: string, password: string) {

    try {
      const signIn: SignInInput = { username: mail, password: password };
      const { isSignedIn, nextStep } = await this.cognitoService.handleSignIn(signIn);
      if (!isSignedIn) {
        this.verifyState(nextStep);
      } else {
        this.router.navigateByUrl("/account-verification");
      }
    } catch (error) {
      if (error instanceof AuthError) {
        switch (error.name) {
          case "NotAuthorizedException":
            const title = await this.traslateService.get('NOTIFI.titleWarning').toPromise();
            const detail = await this.traslateService.get(`ERRORS.invalidCredentials`).toPromise();
            this.notificationService.showWarning(title, detail)
            break;
          case "UserAlreadyAuthenticatedException":
            const detailB = await this.traslateService.get(`ERRORS.userSession`).toPromise();
            this.notificationService.showError(title, detailB);
            break;
          default:
            const detailC = await this.traslateService.get(`ERRORS.Error`).toPromise();
            this.notificationService.showError(title, detailC)
            break;
        }
      } else {
        const title = await this.traslateService.get('NOTIFI.titleError').toPromise();
        const detail = await this.traslateService.get(`ERRORS.Error`).toPromise();
        this.notificationService.showError(title, detail)
      }
      this.loading = false;
    }
  }

  async verifyState(output: any) {
    const { signInStep, totpSetupDetails } = output;
    switch (signInStep) {
      case 'CONTINUE_SIGN_IN_WITH_TOTP_SETUP':
        console.log(totpSetupDetails.sharedSecret);
        const appName = 'AdminTotaldoc';
        const setupUri = totpSetupDetails.getSetupUri(appName);
        localStorage.setItem("uri", setupUri.href);
        this.router.navigateByUrl('/account-mfa');
        break;
      case 'CONFIRM_SIGN_UP':
        await this.cognitoService.handleResendSignUpCode(this.loginForm.value['user']!);
        localStorage.setItem("username", this.loginForm.value['user']!);
        this.router.navigateByUrl("/account-confirmation");
        break;
      case 'CONFIRM_SIGN_IN_WITH_TOTP_CODE':
        this.router.navigateByUrl("/account-verification");
        break;
    }
  }

  /**
   * Password Hide/Show
   */
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

}